module.exports = __webpack_public_path__ + "fa8d7ab650922294d78791ea3fe617cb.jpg";